module.exports = __webpack_public_path__ + "img/icon-meta-item.2e3eb986.svg";